import React, { createContext, useState, useEffect } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { getCoordinatorDetails } from '../core/api';

export const CoordinatorContext = createContext();

export const CoordinatorProvider = ({ children }) => {
  const [coordinator, setCoordinator] = useState(null);
  const auth = getAuth();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const details = await getCoordinatorDetails(user?.email);
        setCoordinator({ ...details, email: user?.email });
      } else {
        setCoordinator({ email: user?.email });
      }
    });
    return () => unsubscribe();
  }, [auth]);

  return (
    <CoordinatorContext.Provider value={{ coordinator }}>
      {children}
    </CoordinatorContext.Provider>
  );
};